import { render, staticRenderFns } from "./ProjectFundingAccountLabel.vue?vue&type=template&id=4ecfdec7&scoped=true"
import script from "./ProjectFundingAccountLabel.vue?vue&type=script&lang=ts"
export * from "./ProjectFundingAccountLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecfdec7",
  null
  
)

export default component.exports